module.exports = __webpack_public_path__ + "img/recouvrement.b28903a7.png";